import { nanoid } from '@reduxjs/toolkit';

import { ContentSurveysFormValues } from '../../types';

export const initialValues: ContentSurveysFormValues = {
  common: {
    name: '',
  },
  questions: [
    {
      content: {
        data: '{}',
        attachments: [],
        hasContent: false,
      },
      answerSettings: [
        {
          id: nanoid(),
          answers: [],
          type: null as unknown as 'one' | 'several' | 'text',
        },
      ],
    },
  ],
  settings: {
    anonymous: '1',
    showAnswers: '0',
  },
};
